import {deletePopover} from "../../../hoc/deletePopover";

const DeleteBoard = deletePopover("DeleteBoard");
export default DeleteBoard;
